import {getThemeName} from "./themeUtils";

export function generateSrcsetForImage(fileName) {
    const lastDotIndex = fileName.lastIndexOf('.');
    const filePrefix = fileName.substr(0, lastDotIndex);
    const fileExtension = fileName.substr(lastDotIndex);

    return `${imagePath(`${filePrefix}_sm${fileExtension}`)} 580w,
            ${imagePath(`${filePrefix}_md${fileExtension}`)} 760w,
            ${imagePath(`${filePrefix}_lg${fileExtension}`)} 1080w,
            ${imagePath(`${filePrefix}_xl${fileExtension}`)} 1920w`;
}

export function imagePath(fileName) {
    return require(`../resources/images/${fileName}`);
}

export function themableImagePath(fileName) {
    const themeName = getThemeName();
    return require(`../resources/images/theme/${themeName}/${fileName}`);
}